import CloudFunctions from "@/api/cloudFunctions/CloudFunctions";
import { useState } from "react";

interface ProfileModel {
  userName: string;
  email: string;
  fullName: string;
  profileLogoUrl: string;
  phoneNumber: string;
  client: string;
}

interface UseGetRandomChallengeUser {
  status: boolean;
  randomUser: ProfileModel | null;
  error: Error | null;
}

// For admins
const useGetRandomChallengeUser = (slug: string) => {
  const [user, setUser] = useState<ProfileModel | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);

    try {
      await CloudFunctions.callCloudFunction("getRandomChallengeUser", {
        challengeSlug: slug,
      })
        // .then((response: { data: ProfileModel }) => {
        .then((response: UseGetRandomChallengeUser) => {
          console.log("Response from getRandomChallengeUser:", response);
          if (response.status) {
            setUser(response.randomUser);
          } else {
            setError(new Error("No user found for the given challenge slug"));
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setError(err);
          setLoading(false);
        });
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchData = async () => {
  //   setLoading(true);

  //   try {
  //     await cloudFunction("ManageBrands", {
  //       type: "read",
  //       tenantId: brand.tenantId,
  //     })
  //       .then((response: { data: BaseBrandModel[] }) => {
  //         setBrands(response.data);
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setError(err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   } catch (err) {
  //     setError(err as Error);
  //     setLoading(false);
  //   }
  //   setLoading(false);
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  return { data: user, loading, error, fetchData };
};

export default useGetRandomChallengeUser;
